import React from 'react';
import { Box, Text } from '@chakra-ui/react';

export const MessageHelper = ({ color, children }) => (
  <Box mt={1}><Text color={color || 'textMuted'}>{children}</Text></Box>
);

export default MessageHelper;
